module.exports = __webpack_public_path__ + "static/media/file-powerpoint.d4824247.svg";